export default __webpack_public_path__ + "static/media/img1.c494072a.jpg";